























































//components
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

// utils
import mixins from '@/utils/mixins';
import { AxiosError } from 'axios';
import { mapActions } from 'vuex';
import { ALForm } from '@/common/component.types';
import { ErrorManager } from '@/models/error';

//mixins
import FormRules from '@/mixins/file-upload-rules';

const baseMixins = mixins(FormRules);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'EmployeeUploadFormDialog',

    components: { ALDialog, ErrorAlert, DragDropFileInput },

    data: () => ({
      dialog: false,
      loading: false,
      file_upload: null as File | null,

      errorMessage: '',
      errorMessageDetail: '',

      employeeUploadFormValid: false
    }),

    watch: {
      dialog(value: boolean) {
        if (!value) {
          this.file_upload = null;
        }
      }
    },

    methods: {
      ...mapActions({
        uploadHourlyEmployees: 'employee/uploadHourlyEmployees'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open() {
        this.clearAllErrors();
        this.dialog = true;
        this.resetFormValidation();
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.errorMessageDetail = '';
      },

      close() {
        this.clearAllErrors();
        this.dialog = false;
      },

      async uploadHourlyEmployeesHandler() {
        if (this.validateForm()) {
          this.clearAllErrors();

          this.loading = true;
          await this.uploadHourlyEmployees(this.file_upload)
            .then(() => {
              this.file_upload = null;
              this.$emit('employee:upload');
              this.close();
            })
            .catch((error: AxiosError) => {
              if (error.response) {
                // client received an error response that falls out of range 2xx
                if (error.response.data.detail) {
                  this.errorMessageDetail = error.response.data.detail;
                }
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    }
  });
